var sliceStr = function (str, len) {
  var len = len || 8;
  if (str != null) {
    if (str.length > len) {
      return str.substring(0, len) + "...";
    } else {
      return str;
    }
  }
  return '';
}

var rangesFromDiff = function(diff, textLength) {
  var ranges = [];
  var activeCount = 0;
  var rangeStart = -1;

  for (var index = 0; index < textLength; index++) {
    activeCount += diff[index];
    if (activeCount > 0 && rangeStart === -1) {
      rangeStart = index;
    }
    if (activeCount === 0 && rangeStart !== -1) {
      ranges.push({ start: rangeStart, end: index });
      rangeStart = -1;
    }
  }

  if (rangeStart !== -1) {
    ranges.push({ start: rangeStart, end: textLength });
  }

  return ranges;
}

var buildTextWindows = function(text, windowLength) {
  var windows = new Set();
  for (var i = 0; i <= text.length - windowLength; i++) {
    windows.add(text.slice(i, i + windowLength));
  }
  return windows;
}

var findOverlapRangesWithWindows = function(sourceText, targetWindows, windowLength) {
  if (sourceText.length < windowLength || targetWindows.size === 0) {
    return [];
  }

  // 差分数组用于线性合并大量重叠窗口，避免反复拼接区间。
  var diff = new Int32Array(sourceText.length + 1);
  for (var i = 0; i <= sourceText.length - windowLength; i++) {
    if (targetWindows.has(sourceText.slice(i, i + windowLength))) {
      diff[i] += 1;
      diff[i + windowLength] -= 1;
    }
  }

  return rangesFromDiff(diff, sourceText.length);
}

/**
 * 查找 source 中所有属于“连续重复 minLength 字及以上”的区间。
 * 固定长度窗口和差分数组使时间、空间消耗都随文本长度线性增长。
 */
var findOverlapRanges = function(source, target, minLength) {
  var sourceText = String(source == null ? '' : source);
  var targetText = String(target == null ? '' : target);
  var windowLength = Number.isInteger(minLength) && minLength > 0 ? minLength : 5;

  if (sourceText.length < windowLength || targetText.length < windowLength) {
    return [];
  }

  return findOverlapRangesWithWindows(
    sourceText,
    buildTextWindows(targetText, windowLength),
    windowLength
  );
}

// 保留旧工具函数的导出形式，但内部改为线性区间算法。
var highLight = function(source, target, step) {
  var sourceText = String(source == null ? '' : source);
  return findOverlapRanges(sourceText, target, step)
    .map(range => sourceText.slice(range.start, range.end));
}

var highlightPlainTextInHtml = function(content, keywords, color = '#FF9C07') {
  var rawContent = String(content == null ? '' : content);
  var list = Array.from(new Set(keywords || []))
    .map(keyword => String(keyword == null ? '' : keyword))
    .filter(Boolean);

  if (list.length === 0 || typeof document === 'undefined') {
    return rawContent;
  }

  var container = document.createElement('div');
  container.innerHTML = rawContent;
  var plainText = container.textContent || container.innerText || '';
  var diff = new Int32Array(plainText.length + 1);

  list.forEach(keyword => {
    var searchFrom = 0;
    while (searchFrom <= plainText.length - keyword.length) {
      var matchIndex = plainText.indexOf(keyword, searchFrom);
      if (matchIndex === -1) {
        break;
      }

      diff[matchIndex] += 1;
      diff[matchIndex + keyword.length] -= 1;
      searchFrom = matchIndex + 1;
    }
  });

  return highlightHtmlByRanges(rawContent, rangesFromDiff(diff, plainText.length), color);
}

var highlightHtmlByRanges = function(content, ranges, color = '#FF9C07') {
  var rawContent = String(content == null ? '' : content);
  var safeRanges = Array.isArray(ranges)
    ? ranges.filter(range => range && range.start < range.end)
    : [];

  if (safeRanges.length === 0 || typeof document === 'undefined') {
    return rawContent;
  }

  var container = document.createElement('div');
  container.innerHTML = rawContent;
  // NodeFilter.SHOW_TEXT === 4；直接使用常量以兼容部分旧 WebView 未暴露 NodeFilter 全局变量的情况。
  var walker = document.createTreeWalker(container, 4);
  var textNodes = [];
  var plainOffset = 0;
  var node;

  while ((node = walker.nextNode())) {
    var textLength = (node.nodeValue || '').length;
    textNodes.push({
      node: node,
      start: plainOffset,
      end: plainOffset + textLength
    });
    plainOffset += textLength;
  }

  textNodes.forEach(item => {
    var intersections = [];

    for (var i = 0; i < safeRanges.length; i++) {
      var range = safeRanges[i];
      if (range.end <= item.start) continue;
      if (range.start >= item.end) break;

      var localStart = Math.max(range.start, item.start) - item.start;
      var localEnd = Math.min(range.end, item.end) - item.start;
      if (localStart < localEnd) {
        intersections.push({ start: localStart, end: localEnd });
      }
    }

    if (intersections.length === 0 || !item.node.parentNode) return;

    var originalText = item.node.nodeValue || '';
    var fragment = document.createDocumentFragment();
    var cursor = 0;

    intersections.forEach(range => {
      if (range.start > cursor) {
        fragment.appendChild(document.createTextNode(originalText.slice(cursor, range.start)));
      }

      var highlightNode = document.createElement('span');
      highlightNode.className = 'overlap-highlight';
      highlightNode.style.color = color;
      highlightNode.textContent = originalText.slice(range.start, range.end);
      fragment.appendChild(highlightNode);
      cursor = range.end;
    });

    if (cursor < originalText.length) {
      fragment.appendChild(document.createTextNode(originalText.slice(cursor)));
    }

    item.node.parentNode.replaceChild(fragment, item.node);
  });

  return container.innerHTML;
}

/**
 * 在 Web Worker 中批量计算区间，使异常长的粘贴内容也不会锁死页面主线程。
 * 构造 Worker 失败时会自动回退到同一套线性算法。
 */
var createFallbackOverlapTask = function(targetText, sourceList, windowLength) {
  var targetWindows = buildTextWindows(targetText, windowLength);
  return {
    promise: Promise.resolve(
      sourceList.map(source => findOverlapRangesWithWindows(source, targetWindows, windowLength))
    ),
    cancel: function() {}
  };
}

var createOverlapWorkerTask = function(target, sources, minLength, workerTimeoutMs = 3000) {
  var sourceList = Array.isArray(sources) ? sources.map(source => String(source == null ? '' : source)) : [];
  var targetText = String(target == null ? '' : target);
  var windowLength = Number.isInteger(minLength) && minLength > 0 ? minLength : 5;
  var timeoutMs = Number.isFinite(workerTimeoutMs) && workerTimeoutMs >= 0 ? workerTimeoutMs : 3000;
  var calculateSynchronously = function() {
    var targetWindows = buildTextWindows(targetText, windowLength);
    return sourceList.map(source => findOverlapRangesWithWindows(source, targetWindows, windowLength));
  };

  if (typeof Worker === 'undefined') {
    return {
      promise: Promise.resolve(calculateSynchronously()),
      cancel: function() {}
    };
  }

  var worker;
  try {
    worker = new Worker(`${process.env.BASE_URL || '/'}overlap.worker.js?v=1`);
  } catch (error) {
    return createFallbackOverlapTask(targetText, sourceList, windowLength);
  }

  var rejectTask;
  var settled = false;
  var timeoutId = null;
  var promise = new Promise((resolve, reject) => {
    rejectTask = reject;

    var terminateWorker = function() {
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      try {
        worker.terminate();
      } catch (error) {
        // Worker 已终止或浏览器实现不完整时不影响结果收口。
      }
    };

    var resolveWithFallback = function() {
      if (settled) return;
      settled = true;
      terminateWorker();
      try {
        resolve(calculateSynchronously());
      } catch (error) {
        reject(error);
      }
    };

    timeoutId = setTimeout(resolveWithFallback, timeoutMs);

    try {
      worker.onmessage = function(event) {
        if (settled) return;
        var data = event && event.data;
        if (!data || data.error || !Array.isArray(data.results)) {
          resolveWithFallback();
          return;
        }
        settled = true;
        terminateWorker();
        resolve(data.results);
      };

      worker.onerror = resolveWithFallback;

      worker.postMessage({
        target: targetText,
        sources: sourceList,
        minLength: windowLength
      });
    } catch (error) {
      resolveWithFallback();
    }
  });

  return {
    promise: promise,
    cancel: function() {
      if (settled) return;
      settled = true;
      if (timeoutId !== null) {
        clearTimeout(timeoutId);
        timeoutId = null;
      }
      try {
        worker.terminate();
      } catch (terminateError) {
        // 取消任务的结果应始终保持 AbortError，不受 Worker 实现影响。
      }
      var error = new Error('重合度计算已取消');
      error.name = 'AbortError';
      rejectTask(error);
    }
  };
}

var myReplace = function (content) {
  content = content.replace(" ", "&nbsp;");
  if (content.indexOf(" ") != -1) {
    return myReplace(content);
  }

  return content;
}
module.exports.myReplace = myReplace;
module.exports.highLight = highLight;
module.exports.sliceStr = sliceStr;
module.exports.highlightPlainTextInHtml = highlightPlainTextInHtml;
module.exports.findOverlapRanges = findOverlapRanges;
module.exports.highlightHtmlByRanges = highlightHtmlByRanges;
module.exports.createOverlapWorkerTask = createOverlapWorkerTask;
